export enum NotificationDeliveryType {
  REGULAR = 'regular',
  POPUP = 'popup',
  EMAIL = 'email',
  PUSH = 'push'
}
